module.exports = __webpack_public_path__ + "assets/img/synonyms.58271519.png";